import React, { useEffect, useState } from 'react'
import axios from "axios";
import { newBaseUrl } from "../../Consts"
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
import { useAuth } from '../../Context/AuthContext';

function Profile() {
    const navigate = useNavigate();
    const { isUser } = useAuth();
    const [loading, setLoading] = useState(false);

    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [name, setName] = useState(isUser?.name || '');
    const [email, setEmail] = useState(isUser?.email || '');

    async function handleSaveClick() {
        setLoading(true);
        try {
            const res = await axios.post(`${newBaseUrl}/api/admin/update-profile`, { name, email }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            toast.success('Profile updated successfully');
        } catch {
            toast.error('Error updating profile');
        } finally {
            setLoading(false);
        }
    }

    async function handlePasswordChange() {
        if (!oldPassword || !newPassword || !confirmPassword) return toast.warning('Please fill all fields');
        if (newPassword !== confirmPassword) return toast.error('Passwords do not match');

        setLoading(true);
        try {
            await axios.post(`${newBaseUrl}/api/admin/change-password`, {
                old_password: oldPassword,
                new_password: newPassword,
                new_password_confirmation: confirmPassword,
            }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            toast.success('🔒 Password changed successfully');
            setShowPasswordModal(false);
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Failed to change password');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <ToastContainer autoClose={3000} pauseOnFocusLoss={false} pauseOnHover={false} />
            {(loading || !isUser) ? <LoadingOverlay /> :
                <div className="bg-[#fff] rounded-lg py-[50px] px-[50px] h-[100%]">
                    <div className="space-y-5 flex flex-col justify-start text-start">
                        <div>
                            <label className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                            >
                                Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                className="border border-[#DFEAF2] rounded-xl text-[14px] font-[Cairo] w-full p-3 focus:outline-none focus:ring-2 focus:ring-[#0966AE]/50"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>

                        <div>
                            <label className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                            >
                                Email <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="email"
                                className="border border-[#DFEAF2] rounded-xl text-[14px] font-[Cairo] w-full p-3 focus:outline-none focus:ring-2 focus:ring-[#0966AE]/50"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="mt-4 flex justify-between items-center">
                            <p className="text-[15px] font-[Cairo] text-gray-600">
                                Want to change your password?
                            </p>
                            <button
                                onClick={() => setShowPasswordModal(true)}
                                className="font-[200] text-[#fff] px-5 rounded-lg py-2 bg-[#0966AE] font-[Cairo]"
                            >
                                Change Password
                            </button>
                        </div>

                        <div className="pt-6">
                            <button
                                onClick={handleSaveClick}
                                className="text-[20px] font-[200] text-[#fff] px-5 rounded-lg py-2 bg-[#0966AE] font-[Cairo]"
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            }

            {/* Popup بدون أنيميشن */}
            {showPasswordModal && (
                <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-8 w-[400px] shadow-2xl relative">
                        <h3 className="text-[20px] font-[Cairo] text-[#0966AE] mb-5 text-center font-semibold">
                            Change Password
                        </h3>

                        <div className="space-y-4">
                            <input
                                type="password"
                                placeholder="Old password"
                                className="border border-[#DFEAF2] rounded-lg p-3 w-full font-[Cairo] focus:ring-2 focus:ring-[#0966AE]/40"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />
                            <input
                                type="password"
                                placeholder="New password"
                                className="border border-[#DFEAF2] rounded-lg p-3 w-full font-[Cairo] focus:ring-2 focus:ring-[#0966AE]/40"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <input
                                type="password"
                                placeholder="Confirm new password"
                                className="border border-[#DFEAF2] rounded-lg p-3 w-full font-[Cairo] focus:ring-2 focus:ring-[#0966AE]/40"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                        </div>

                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                onClick={() => setShowPasswordModal(false)}
                                className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg font-[Cairo] hover:bg-gray-300 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handlePasswordChange}
                                className="bg-[#0966AE] text-white px-4 py-2 rounded-lg font-[Cairo] hover:bg-[#07548c] transition"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Profile
